'use strict'

export class Margin {
  constructor(container) {
    const contianerWidth = container.getBoundingClientRect().width
    const contianerHeight = container.getBoundingClientRect().height

    this.top = this.calculateTopMargin(contianerHeight)
    this.bottom = this.calculateBottomMargin(contianerHeight)
    this.height = this.calculateHeight(contianerHeight)

    this.left = this.calculateLeftMargin(contianerWidth)
    this.right = this.calculateRightMargin(contianerWidth)
    this.width = this.calculateWidth(contianerWidth)
  }
  calculateTopMargin(height) {
    return height * 0.075757
  }
  calculateBottomMargin(height) {
    return height * 0.196969
  }
  calculateHeight(height) {
    return height - this.top - this.bottom
  }
  calculateLeftMargin(width) {
    return width * 0.0625
  }
  calculateRightMargin(width) {
    return width * 0.0227272727
  }
  calculateWidth(width) {
    return width - this.left - this.right
  }
}
